module.exports = __webpack_public_path__ + "img/yfood-fresh-berry.bbe1914c.png";